module.exports = __webpack_public_path__ + "static/img/information.25a6037a.png";